document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".product-info-menu-item");
  const allSections = document.querySelectorAll(".product-info-right-content > div");

  menuItems?.forEach(item => {
    item.addEventListener("click", () => {
      const target = item.dataset.target;
      const targetSection = document.querySelector(`.product-info-${target}`);
      const isActive = item.classList.contains("active");
      const display = item.dataset.display || '!tw-flex';
      const isMobile = window.innerWidth < 768;

      if (isMobile && isActive) {
        item.classList.remove("active");
        if (targetSection) targetSection.classList.add("display-none");
      } else {
        allSections?.forEach(section => {
          section.classList.remove("display-none");
          if (section.classList.contains(`product-info-${target}`)) {
            section.classList.remove('display-none');
            section.classList.add(display);
          } else {
            section.classList.remove(display);
            section.classList.add('display-none');
          }
        });

        menuItems.forEach(i => i.classList.remove("active"));
        item.classList.add("active");
      }
    });
  });

  
  document.addEventListener('variant:changed', (event) => {
    const factsheetLink = document.querySelector('.factsheet_link[data-base-url]');
    if (!factsheetLink || !event.detail?.variant) return;

    const baseUrl = factsheetLink.dataset.baseUrl;
    const market = factsheetLink.dataset.market;
    const units = factsheetLink.dataset.units;
    const sku = event.detail.variant.sku;

    if (market && units && sku) {
      factsheetLink.href = `${baseUrl}/?market=${market}&units=${units}&sku=${sku}`;
    }
  });
});

  const slider = document.getElementById('scrollable');
  let isDown = false;
  let startX;
  let scrollLeft;

  if (slider) {
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('cursor-grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault();
    });
  
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('cursor-grabbing');
    });
  
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('cursor-grabbing');
    });
  
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
      const image = document.querySelector('.product-info-dimensions .desktop-dimensions-image:not(.no-zoom)');
      
      if (!image) {
          return;
      }

      let lens = null;
      let debugInfo = null;
      const zoomLevel = 2.5;
      const lensSize = 200;

      function createLens() {
          lens = document.createElement('div');
          lens.className = 'magnifier-lens';
          document.body.appendChild(lens);
      }

      function showLens() {
          if (!lens) createLens();
          lens.classList.add('active');
      }

      function hideLens() {
          if (lens) lens.classList.remove('active');
      }

      function updateLens(e) {
          if (!lens) return;

          const rect = image.getBoundingClientRect();
          const x = e.clientX;
          const y = e.clientY;

          lens.style.left = (x - lensSize/2) + 'px';
          lens.style.top = (y - lensSize/2) + 'px';

          const relativeX = (x - rect.left) / rect.width;
          const relativeY = (y - rect.top) / rect.height;
          const clampedX = Math.max(-0.1, Math.min(1.1, relativeX));
          const clampedY = Math.max(-0.1, Math.min(1.1, relativeY));

          const displayWidth = rect.width;
          const displayHeight = rect.height;
          const bgWidth = displayWidth * zoomLevel;
          const bgHeight = displayHeight * zoomLevel;
          
          let bgX;
          let bgY;
          if((clampedX * bgWidth - lensSize/2) < 0){
            bgX = 0;
          }else{
            bgX = clampedX * bgWidth - lensSize/2;
          }

          if((clampedY * bgHeight - lensSize/2) < 0){
            bgY = 0;
          }else{
            bgY = clampedY * bgHeight - lensSize/2;
          }
          
          lens.style.backgroundImage = `url(${image.src})`;
          lens.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
          lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;

      }

      image.addEventListener('mouseenter', showLens);
      image.addEventListener('mouseleave', hideLens);
      image.addEventListener('mousemove', updateLens);
  });